import { Component, OnInit, ViewChild } from '@angular/core';

import { AppInformationService, ArkUnitOfWork, AuthService, SessionInformationService } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { DevExtremeModule, DxChartComponent, DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GeneralFundDialogComponent } from './general-fund-dialog/general-fund-dialog.component';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class ReportComponent implements OnInit {
    batches: any[] = [];
    userAccess = false;
    reviewOnly = true;
    graafschap = false;
    generalFund: any[] = [];
    generalFundOverview: any = [];
    generalFundDistinct: any[] = [];
    thanksgiving: any[] = [];
    dataSource: any[] = [];
    visualRange: any = {};
    visualRangeOffering: any = {};
    monthlyBudget: number;
    monthlyBudget2018 = 51526;
    expenses2018 = 47300;

    offeringHistory: any;
    offeringTotals: any;
    accounts: any;
    selectedAccount: any;
    accountDetail: any;
    budgets: any;
    monthlyBudgetIndicator: any;

    expenses: any;
    monthlyExpense: number;
    monthlyExpenseIndicator: any;

    isReady = false;
    lineStyleValue: string = 'waved'; //, 'straight'];

    executive = false;
    breaks = [
        {
            startValue: 500,
            endValue: 5000,
        },
        {
            startValue: 5000,
            endValue: 24000,
        },
    ];

    seriesState = [];

    onToolbarPreparing = SharedModule.onToolbarPreparing;
    @ViewChild('batchesGrid') dataGrid: DxDataGridComponent;
    @ViewChild('chart') chart: DxChartComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private session: SessionInformationService
    ) {}

    async ngOnInit() {
        this.graafschap = this.appInfo.settings.church === 'graafschap';
        this.budgets = this.uow.lookups.budgets;
        this.expenses = this.uow.lookups.expenses;
        this.executive = this.auth.hasRole('Executive') && !this.auth.hasRole('Administrator');

        if (!!this.budgets && this.budgets.length > 0) {
            this.monthlyBudget = this.budgets[0].amount / 12;
            this.monthlyBudgetIndicator = `${this.budgets[0].year} Budgeted Amount: ${this.monthlyBudget.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}`;
        }
        if (!!this.expenses && this.expenses.length > 0) {
            this.monthlyExpense = this.expenses[0].amount / 12;
            this.monthlyExpenseIndicator = `${this.expenses[0].year} Actual Expenses: ${this.monthlyExpense.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}`;
        }
        this.generalFund = await this.uow.getGeneralFund();
        this.generalFundOverview = await this.uow.getGeneralFundOverview();
        // console.log(this.generalFundOverview );
        this.generalFundDistinct = await this.uow.getGeneralFundDistinct();
        this.offeringTotals = await this.uow.getOfferingTotals();
        this.thanksgiving = await this.uow.getThanksgivingHistory();

        this.accounts = await this.uow.getAccounts();

        this.offeringHistory = await this.uow.getOfferingHistory();
        this.offeringHistory.forEach((x) => {
            // x.date = moment(x.date).toDate();
            x.dateString = x.date;
            // x.dateString = moment(x.date).format('MM/DD/YYYY');
        });
        const max = (_.maxBy(this.offeringHistory, 'date') as any).date;
        // console.log(max);
        this.visualRangeOffering = [moment(max).subtract(2, 'months').toDate().toString(), moment(max).subtract(2, 'days').toDate().toString()];

        // console.log(this.offeringHistory);
        // console.log(this.visualRangeOffering);
        this.loadStateFromLocalStorage();
        this.isReady = true;
    }

    async onAccountChange(e) {
        // console.log(e)
        this.accountDetail = await this.uow.getAccountDetail(this.selectedAccount);
        // console.log(this.accountDetail);
    }

    pointClickHandler(e) {
        this.toggleVisibility(e.target);
    }
    legendClickHandler(e) {
        const arg = e.target,
            item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

        this.toggleVisibility(item);
    }

    toggleVisibility(item) {
        console.log(item);
        if (item.isVisible()) {
            item.hide();
        } else {
            item.show();
        }
    }

    pointClickHandlerOffering = (e) => {
        // console.log(e);
        this.toggleVisibilitySeries(e.target.series);
    };
    legendClickHandlerOffering = (e) => {
        console.log('target', e.target);
        this.toggleVisibilitySeries(e.target);
        this.toggleSeriesVisibility(e.target.index, e.target);
    };

    toggleSeriesVisibility(index: number, target:any) {
        const series = this.seriesState?.find((s) => s.id === index);
        if (!series) {
            this.seriesState.push({ id: index, visible: target.isVisible()});
        }
        else {
            series.visible = target.isVisible();
        }
        // console.log(this.seriesState);
        this.saveStateToLocalStorage();
    }

    saveStateToLocalStorage() {
        // console.log('asdf');
        this.session.setItem('chartSeriesState', JSON.stringify(this.seriesState), true);
    }

    loadStateFromLocalStorage() {
        const storedState = this.session.getItem('chartSeriesState', true);
        if (storedState) {
            this.seriesState = JSON.parse(storedState);
            // console.log('loaded', this.seriesState);
            this.seriesState.forEach((s) => {
                if (!s.visible) {
                    // console.log('instance', this.chart.instance);
                    // console.log('series', (this.chart.instance as any).series[s.id]);
                    (this.chart.instance as any).series[s.id].hide();
                }
            });
        }
    }

    toggleVisibilitySeries(series) {
        if (series.isVisible()) {
            series.hide();
        } else {
            series.show();
        }
    }

    customizeToolTip = (e) => {
        return {
            text: e.seriesName + ' - ' + e.valueText,
        };
    };

    customizeToolTipOffering = (e) => {
        return {
            text: e.argument + ' - ' + e.valueText,
        };
    };

    customizeToolTipOfferingHistory = (e) => {
        // console.log(e);
        if (e.seriesName === 'Total') {
            return {
                text: e.point.data.name + '\n' + e.valueText.toString('$#,##0.00'),
                format: { type: 'currency', precision: '2' },
            };
        }
        if (e.seriesName === 'Count') {
            return {
                text: 'Count: ' + e.valueText,
            };
        }
        return null;
    };

    onRangeMoving = (e) => {
        // console.log(this.visualRangeOffering);
        // return {
        //     text: e.point.data.name + '\n' + e.valueText,
        // };
    };

    onPointClick(e, thanksgiving?: boolean) {
        // console.log(e.target.data);
        if (this.executive && !thanksgiving) return;
        this.openSeries(e.target.data, thanksgiving);
        // if (this.isFirstLevel) {
        //     this.isFirstLevel = false;
        //     this.dataSource = this.service.filterData(e.target.originalArgument);
        // }
    }

    async openSeries(data: any, thanksgiving?: boolean) {
        const modalRef = this.modalService.show(GeneralFundDialogComponent, {
            class: 'modal-mdw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // generalFund: this.generalFund,
                data: data,
                thanksgiving: thanksgiving,
            },
        });

        modalRef.content.result.subscribe((result) => {
            if (result) {
            }
            modalRef.hide();
        });
    }

    // onToolbarPreparing(e) {
    //     e.toolbarOptions.items.unshift({
    //         location: 'before',
    //         template: 'toolbarButtons'
    //     });
    // }
}
